import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код группы отчетности',
    key: 'code',
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Внешний код группы отчетности',
    key: 'code_ext',
  },
  {
    title: 'Наименование группы отчетности',
    key: 'name',
  },
];
